module.exports = "<form> <date-picker label=birthday icon=today :date=\"new Date()\"></date-picker> </form>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/forms/date-picker-demo.vue
 ** module id = 307
 ** module chunks = 0
 **/